
export var _vapidPublicKey = 'BLbYTeZIA58ug-Y1DlhZbcrKT6n6pZCWgrHEOCmFQkAx-tDr7nw-S6sbTynnqCAMidKAwXxKfZq6O5PrX4haxY0';